<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ plant.serialNo }}&nbsp;
                <Badge v-if="plant.stateId === 2" type="warning"
                  >Archived</Badge
                >
              </h4>
            </div>
            <edit-button
              :stateId="plant.stateId"
              @edit-click="editPlant"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Stat. Insp. Frequency:</strong><br />
                  {{ plant.statInspFrequency }} Months
                </p>
                <p>
                  <strong>Plant Type:</strong><br />
                  {{ plant.plantTypeName }}
                </p>
                <p>
                  <strong>Location:</strong><br />
                  {{ plant.location }}
                </p>
                <p>
                  <strong>Invoicing Name</strong><br />
                  {{ plant.invoicingName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Contractor</strong><br />
                  {{ plant.contractorName }}
                </p>
                <p>
                  <strong>Contractor Region</strong><br />
                  {{ plant.contractorRegionName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong><br />
                  <router-link :to="{ name: 'Client' }">
                    {{ plant.clientName }}
                  </router-link>
                </p>
                <p>
                  <strong>Site</strong><br />
                  <router-link :to="{ name: 'Site' }">
                    {{ plant.siteName }}
                  </router-link>
                </p>
                <p>
                  <strong>Building</strong><br />
                  <router-link :to="{ name: 'Building' }">
                    {{ plant.buildingName }}
                  </router-link>
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Badge } from "@/components";

export default {
  components: {
    Badge
  },
  computed: {
    ...mapGetters({
      plant: "data-management-client/plant"
    })
  },
  async created() {
    await this.$store.dispatch(
      "data-management-client/getPlant",
      this.$route.params.plantId
    );
  },
  methods: {
    editPlant() {
      this.$router.push({
        name: "Edit Plant",
        params: { plantId: this.plant.id }
      });
    }
  }
};
</script>

<style></style>
